import { useState } from "react";
import { Message } from "iconsax-reactjs";
import CTAs from "./CTAs";

const FeedbackForm = ({ onClose }) => {
  const user = JSON.parse(localStorage.getItem("authUser"));
  const token = localStorage.getItem("authToken");
  const API_URL = process.env.REACT_APP_API_URL;

  const [selectedOption, setSelectedOption] = useState("");
  const [comments, setComments] = useState("");

  const handleOptionClick = (option) => {
    setSelectedOption(option);
  };

  const sendFeedback = async () => {
    if (!selectedOption) {
      alert("Please select a feedback option before submitting.");
      return;
    }

    const user = JSON.parse(localStorage.getItem("authUser"));
    const name = user?.data?.name || user?.name;
    const email = user?.data?.email || user?.email;

    if (!name || !email) {
      alert("Name, email, and feedback are required.");
      return;
    }

    try {
      console.log("Sending feedback:", {
        name,
        email,
        feedback: selectedOption,
        comments,
      });

      const response = await fetch(`${API_URL}/api/feedback/send-feedback`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name,
          email,
          feedback: selectedOption,
          comments,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        alert("Feedback sent successfully!");
        if (typeof onClose === "function") onClose();
      } else {
        alert(data?.message || "Failed to send feedback.");
      }
    } catch (err) {
      console.error("Network or fetch error:", err);
      alert("Something went wrong while sending feedback (network or CORS).");
    }
  };

  return (
    <div className="w-[480px] relative shadow-[0px_10px_60px_rgba(0,_0,_0,_0.1)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] box-border flex flex-col items-start gap-8 text-left text-base text-neutrals-neutral-900 font-open-sans-ff-meta">
      {/* Header Section */}
      <div className="self-stretch flex flex-col items-start gap-5">
        <div className="self-stretch h-[92px] border-neutrals-neutral-100 border-solid border-b-[1px] box-border flex items-start pt-6 px-6 pb-5">
          <div className="flex-1 flex items-start gap-4">
            <div className="shadow-[0px_-2px_0px_rgba(0,_0,_0,_0.05)_inset,_0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-lg bg-white border-neutrals-neutral-100 border-solid border-[1px] flex items-center p-3">
              <Message />
            </div>
            <div className="flex-1 flex flex-col items-start gap-0.5">
              <div className="self-stretch relative font-semibold">
                Help us improve
              </div>
              <div className="self-stretch relative text-sm text-neutrals-neutral-300">
                Provide feedback for improvement.
              </div>
            </div>
          </div>
          <img
            src="assets/cancel.svg"
            className="h-5 w-5 cursor-pointer"
            onClick={() => {
              if (typeof onClose === "function") onClose();
            }}
          />
        </div>

        {/* Feedback Options (same grid & width) */}
        <div className="self-stretch flex flex-col items-start py-0 px-6 gap-2 text-sm">
          <div className="self-stretch flex items-center gap-2">
            <CTAs
              type="Secondarybtn"
              text="Lets improve a few things"
              borderColor={
                selectedOption === "Lets improve a few things"
                  ? "border-primary-primary-500"
                  : "border-neutrals-neutral-100"
              }
              width="w-full"
              onClick={() => handleOptionClick("Lets improve a few things")}
            />

            <CTAs
              type="Secondarybtn"
              text="Not right for my business"
              borderColor={
                selectedOption === "Not right for my business"
                  ? "border-blue-500"
                  : "border-neutrals-neutral-100"
              }
              width="w-full"
              onClick={() => handleOptionClick("Not right for my business")}
            />
          </div>

          <div className="self-stretch flex items-center gap-2">
            <CTAs
              type="Secondarybtn"
              text="Everything is good"
              borderColor={
                selectedOption === "Everything is good"
                  ? "border-blue-500"
                  : "border-neutrals-neutral-100"
              }
              width="w-full"
              onClick={() => handleOptionClick("Everything is good")}
            />

            <CTAs
              type="Secondarybtn"
              text="Exceeds Expectations"
              borderColor={
                selectedOption === "Exceeds Expectations"
                  ? "border-blue-500"
                  : "border-neutrals-neutral-100"
              }
              width="w-full"
              onClick={() => handleOptionClick("Exceeds Expectations")}
            />
          </div>

          <div className="self-stretch flex items-center gap-2">
            <CTAs
              type="Secondarybtn"
              text="Exceptional"
              borderColor={
                selectedOption === "Exceptional"
                  ? "border-blue-500"
                  : "border-neutrals-neutral-100"
              }
              width="w-[212px]"
              onClick={() => handleOptionClick("Exceptional")}
            />

            {/* <CTAs
              type="Secondarybtn"
              text="Not helpful"
              borderColor={
                selectedOption === "Not helpful"
                  ? "border-blue-500"
                  : "border-neutrals-neutral-100"
              }
              width="w-full"
              onClick={() => handleOptionClick("Not helpful")}
            /> */}
          </div>
        </div>
      </div>

      {/* Text Input Section (identical layout, but editable) */}
      <div className="self-stretch flex flex-col items-start text-sm">
        <div className="self-stretch flex flex-col items-start pt-0 px-6 pb-5 gap-1.5">
          <div className="self-stretch flex items-center gap-1">
            <div className="relative font-semibold">
              Suggest improvements or ideas for us to build and implement so we
              can make 6EL∆ better for you.
            </div>
            {/* <div className="relative text-neutrals-neutral-300">(Optional)</div> */}
          </div>

          {/* Editable textarea with same styling */}
          <textarea
            placeholder="Ex. More specific based on your selection"
            value={comments}
            onChange={(e) => setComments(e.target.value)}
            className="self-stretch shadow-[0px_1px_2px_rgba(0,_0,_0,_0.05)] rounded-3xs bg-white border-neutrals-neutral-100 border-solid border-[1px] overflow-hidden flex items-center p-3 text-base text-neutrals-neutral-900 font-open-sans-ff-meta placeholder:text-neutrals-neutral-300 focus:outline-none focus:ring-1 focus:ring-blue-400 resize-none"
            rows={4}
          />
        </div>

        {/* Footer Section */}
        <div className="self-stretch h-[95px] rounded-t-none rounded-b-xl border-neutrals-neutral-100 border-solid border-t-[1px] box-border flex items-center justify-center pt-8 px-6 pb-6 gap-3">
          <CTAs
            type="Secondarybtn"
            text="Cancel"
            borderColor="border-neutrals-neutral-100"
            width="w-[210px]"
            onClick={() => {
              if (typeof onClose === "function") onClose();
            }}
          />

          <CTAs
            type="Gradientbtn"
            text="Submit"
            width="w-[210px]"
            onClick={sendFeedback}
          />
        </div>
      </div>
    </div>
  );
};

export default FeedbackForm;
